// extracted by mini-css-extract-plugin
export default {"root":"Tree_root__EeQk-"};